module.exports = __webpack_public_path__ + "img/GH-corporate-031.984d87fa.jpg";